import { Pipe, PipeTransform } from "@angular/core";
import { AgeHelper } from "../shared/helpers/age.helper";

@Pipe({
    standalone: true,
    name: 'age'
})
export class ExtractAgePipe implements PipeTransform {
    
    /**
     * Función que permite obtener la edad a partir de la fecha de nacimiento y regresa la cadena como tal en dias, meses o años.
     * @param birthdate Parámetro que recibe la fecha de nacimiento para obtener la edad en años, meses o días.
     * @returns El valor retornado es una cadena con el numero y el tiempo. Ejemplo: '35 años', '5 meses', '6 dias de edad'
     */
    transform(birthdate : Date): string {
        let ageString: string = AgeHelper.getAgeComplete(birthdate);
        return ageString;
    }
}